import { app } from '../../../bootstrap/core';
import toggleControlComponent from './toggleControl.component';

app.component('toggleControl', toggleControlComponent);



// WEBPACK FOOTER //
// ./src/app/common/ui/toggleControl/toggleControl.js